import { NgModule } from '@angular/core';
import { ButtonModule } from '../../../shared/button/button.module';
import { SharedModule } from '../../../shared/shared.module';
import { CategoriesService } from '../../../../services/accounting/categories.service';
import { ChartOfAccountsService } from '../../../../services/accounting/chart-of-accounts.service';
import { CloneService } from '../../../../services/clone.service';
import { ControlResetService } from '../../../shared/control-reset.service';
import { ChartOfAccountsComponent } from './chart-of-accounts.component';
import { LFDropdownModule } from '../../../shared/dropdown/dropdown.module';
import { ModalModule } from '../../../shared/modal/modal.module';
import { PlaceholderModule } from '../../../shared/placeholder/placeholder.module';
import { TabbedChangerCallbackModule } from '../../shared/tab-changers/tabbed-changer-callback/tabbed-changer-callback.module';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { LegfiCurrencyPipe } from '../../../../pipes/format/legfi-currency.pipe';
import { DatepickerModule } from '../../../shared/datepicker/datepicker.module';
import { CurrencyInputModule } from '../../../shared/currency-input/currency-input.module';
import { LegfiDatePipeModule } from '../../../../pipes/format/legfi-date.module';
import { LegfiDatePipe } from '../../../../pipes/format/legfi-date.pipe';
import { BudgetCategoryTreeModule } from './budget-category-tree/budget-category-tree.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        LFDropdownModule,
        // Dependencies
        ModalModule,
        PlaceholderModule,
        DatepickerModule,
        CurrencyInputModule,
        TabbedChangerCallbackModule,
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
        BudgetCategoryTreeModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatSlideToggleModule,
        MatInputModule,
        ButtonModule,
    ],
    declarations: [ChartOfAccountsComponent],
    providers: [
        CategoriesService,
        ChartOfAccountsService,
        CloneService,
        ControlResetService,
        LegfiCurrencyPipe,
        LegfiDatePipe,
    ],
})
export class ChartOfAccountsCoreModule
{
}
